/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/contains.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns a boolean that indicates whether a keyword substring is within another string.\nReturns `null` if either parameter is null.',
  examples: [
    'ROW a = "hello"\n| EVAL has_ll = CONTAINS(a, "ll")',
  ],
  params: {
    string: 'String expression: input string to check against. If `null`, the function returns `null`.',
    substring: 'String expression: A substring to find in the input string. If `null`, the function returns `null`.',
  },
};

export default docs;
